/* NUARIVA v2 — swipe sliders, bundles, also-bought, recently viewed, gallery swipe, footer accordion. */
(function () {
  'use strict';
  var R = window.NuarivaRoutes || { cartAdd: '/cart/add.js', cart: '/cart', cartJs: '/cart.js', root: '/' };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : String(s); return d.innerHTML; }
  function money(cents) {
    var fmt = window.NuarivaMoney || '{{amount_with_comma_separator}} €';
    var t = document.createElement('textarea'); t.innerHTML = String(fmt).replace(/<[^>]*>/g, ''); fmt = t.value;
    var n = cents / 100;
    function d(num, prec, th, dec) { var p = num.toFixed(prec).split('.'); return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] ? dec + p[1] : ''); }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return d(n, 2, ',', '.');
      if (k === 'amount_no_decimals') return d(n, 0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, 0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return d(n, 2, "'", '.');
      if (k === 'amount_with_space_separator') return d(n, 2, ' ', ',');
      if (k === 'amount_with_period_and_space_separator') return d(n, 2, ' ', '.');
      return d(n, 2, '.', ',');
    });
  }
  function cleanTitle(t) { return String(t || '').replace(/^\s*n(?:au|ua)riva\s*[-–]\s*/i, ''); }
  function isMobile() { return window.innerWidth < 750; }

  /* ================= Swipe sliders ================= */
  $$('[data-nua-slider]').forEach(function (root) {
    var wrap = $('.nua-track-wrap', root), track = $('[data-track]', root);
    if (!wrap || !track) return;
    var items = Array.prototype.slice.call(track.children);
    if (!items.length) return;
    var center = function () { return isMobile() && root.getAttribute('data-mobile') === 'center'; };
    var dots = document.createElement('div');
    dots.className = 'nua-dots';
    items.forEach(function (_, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.setAttribute('aria-label', 'Ir a ' + (i + 1));
      b.addEventListener('click', function () { go(i); pause(5000); });
      dots.appendChild(b);
    });
    wrap.parentNode.insertBefore(dots, wrap.nextSibling);

    function targetLeft(i) {
      var it = items[i];
      if (center()) return it.offsetLeft - (wrap.clientWidth - it.offsetWidth) / 2;
      var padL = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      return it.offsetLeft - padL;
    }
    function current() {
      var best = 0, bestD = Infinity;
      items.forEach(function (it, i) { var dd = Math.abs(targetLeft(i) - wrap.scrollLeft); if (dd < bestD) { bestD = dd; best = i; } });
      return best;
    }
    function maxIndex() {
      if (center()) return items.length - 1;
      var maxLeft = wrap.scrollWidth - wrap.clientWidth - 2;
      for (var i = 0; i < items.length; i++) { if (targetLeft(i) >= maxLeft) return i; }
      return items.length - 1;
    }
    function go(i) {
      var m = maxIndex();
      if (i > m) i = 0;
      if (i < 0) i = m;
      wrap.scrollTo({ left: Math.max(0, targetLeft(i)), behavior: reduced ? 'auto' : 'smooth' });
    }
    function paint() {
      var scrollable = wrap.scrollWidth > wrap.clientWidth + 4;
      dots.hidden = !scrollable;
      var c = current(), m = maxIndex();
      $$('button', dots).forEach(function (b, i) { b.hidden = i > m; b.setAttribute('aria-current', i === Math.min(c, m) ? 'true' : 'false'); });
    }
    var raf;
    wrap.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(paint); }, { passive: true });
    window.addEventListener('resize', paint);
    $$('[data-dir]', root).forEach(function (b) { b.addEventListener('click', function () { go(current() + parseInt(b.getAttribute('data-dir'), 10)); pause(6000); }); });

    var pausedUntil = 0, hover = false;
    function pause(ms) { pausedUntil = Date.now() + ms; }
    wrap.addEventListener('pointerenter', function () { hover = true; });
    wrap.addEventListener('pointerleave', function () { hover = false; });
    wrap.addEventListener('touchstart', function () { pause(8000); }, { passive: true });
    wrap.addEventListener('focusin', function () { pause(8000); });
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    if (!reduced) setInterval(function () {
      if (hover || document.hidden || Date.now() < pausedUntil) return;
      if (wrap.scrollWidth <= wrap.clientWidth + 4) return;
      go(current() + 1);
    }, interval);
    if (center()) wrap.scrollLeft = Math.max(0, targetLeft(0));
    paint();
  });

  /* ================= Mobile gallery swipe ================= */
  $$('[data-nua-gallery]').forEach(function (g) {
    var main = $('.nua-gallery__main', g); if (!main) return;
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      var btn = $('[data-nua-shot="' + (dx < 0 ? '1' : '-1') + '"]', g);
      if (btn) btn.click();
      var active = $('[data-nua-thumb][aria-pressed="true"]', g);
      if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    }, { passive: true });
  });

  /* ================= Size equivalence ================= */
  $$('[data-nua-fit]').forEach(function (el) {
    var map = {};
    String(el.getAttribute('data-fit') || '').split(/\n/).forEach(function (line) {
      var i = line.indexOf(':'); if (i < 1) return;
      map[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim();
    });
    var group = el.closest('.nua-opt');
    function upd() {
      var b = group && $('[aria-pressed="true"]', group);
      var v = b ? map[String(b.getAttribute('data-value')).toLowerCase()] : '';
      el.innerHTML = v ? esc(el.getAttribute('data-label') || '') + ' <strong>' + esc(v) + '</strong>' : '';
    }
    if (group) group.addEventListener('click', function () { setTimeout(upd, 0); });
    upd();
  });

  /* ================= Bundles ================= */
  $$('[data-nua-bundle]').forEach(function (bundle) {
    var root = bundle.closest('[data-nua-product]'); if (!root) return;
    var sid = root.getAttribute('data-section');
    var jsonEl = document.querySelector('[data-nua-product-json="' + sid + '"]'); if (!jsonEl) return;
    var data = JSON.parse(jsonEl.textContent);
    var options = []; try { options = JSON.parse(bundle.getAttribute('data-options')) || []; } catch (e) {}
    var tiers = $$('[data-nua-tier]', bundle);
    var active = tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0];
    var idInput = $('[data-nua-variant-id]', root);
    var atc = $('[data-nua-atc]', root), msg = $('[data-nua-atc-msg]', root);
    var gift = $('[data-nua-gift]', bundle);
    var colorIdx = -1;
    options.forEach(function (n, i) { if (/colou?r|colore/i.test(n)) colorIdx = i; });
    var values = options.map(function (_, i) {
      var seen = [];
      data.variants.forEach(function (v) { if (seen.indexOf(v.options[i]) < 0) seen.push(v.options[i]); });
      return seen;
    });
    function swatchFor(val) {
      var btn = $$('.nua-swatch', root).filter(function (b) { return b.getAttribute('data-value') === val; })[0];
      var sp = btn && $('span', btn);
      return sp ? sp.style.getPropertyValue('--sw') : '';
    }
    function currentVariant() {
      return data.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || data.variants[0];
    }
    function findVariant(opts) {
      return data.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    var touchedRows = false;
    function buildRows(tier, force) {
      var box = $('[data-tier-items]', tier); if (!box) return;
      if (touchedRows && !force && box.querySelector('.nua-item')) return;
      $$('.nua-item', box).forEach(function (n) { n.remove(); });
      var cv = currentVariant(), qty = parseInt(tier.getAttribute('data-qty'), 10) || 1;
      for (var r = 0; r < qty; r++) {
        var row = document.createElement('div'); row.className = 'nua-item';
        row.innerHTML = '<span class="nua-item__n">#' + (r + 1) + '</span>';
        options.forEach(function (name, oi) {
          var wrapSel = document.createElement('span');
          wrapSel.className = 'nua-item__sel' + (oi === colorIdx ? ' nua-item__sel--color' : '');
          var sel = document.createElement('select');
          sel.setAttribute('aria-label', name + ' #' + (r + 1));
          values[oi].forEach(function (val) {
            var o = document.createElement('option'); o.value = val; o.textContent = val;
            if (cv && cv.options[oi] === val) o.selected = true;
            sel.appendChild(o);
          });
          wrapSel.appendChild(sel);
          if (oi === colorIdx) {
            var dot = document.createElement('span'); dot.className = 'nua-item__dot';
            var paintDot = function () { var sw = swatchFor(sel.value); if (sw) dot.style.setProperty('--sw', sw); };
            paintDot(); sel.addEventListener('change', paintDot);
            wrapSel.insertBefore(dot, sel);
          }
          sel.addEventListener('change', function () { touchedRows = true; });
          sel.addEventListener('click', function (e) { e.stopPropagation(); });
          row.appendChild(wrapSel);
        });
        box.appendChild(row);
      }
    }
    function rowVariants(tier) {
      var out = [];
      $$('.nua-item', tier).forEach(function (row) {
        var opts = $$('select', row).map(function (s) { return s.value; });
        out.push(findVariant(opts));
      });
      return out;
    }
    function paintPrices() {
      var cv = currentVariant(); if (!cv) return;
      tiers.forEach(function (t) {
        var qty = parseInt(t.getAttribute('data-qty'), 10) || 1, paid = Math.min(qty, parseInt(t.getAttribute('data-paid'), 10) || qty);
        var unitCmp = Math.max(cv.compare || 0, cv.price);
        var p = $('[data-tier-price]', t), c = $('[data-tier-compare]', t);
        if (p) p.textContent = money(cv.price * paid);
        if (c) c.textContent = money(unitCmp * qty);
      });
    }
    function paintAtc() {
      var cv = currentVariant();
      if (!atc || !cv || !cv.available) return;
      var qty = parseInt(active.getAttribute('data-qty'), 10) || 1, paid = Math.min(qty, parseInt(active.getAttribute('data-paid'), 10) || qty);
      atc.innerHTML = esc(data.atcLabel) + ' · <span data-nua-total>' + esc(money(cv.price * paid)) + '</span>';
    }
    function paintGift() {
      if (!gift) return;
      var unlocked = (parseInt(active.getAttribute('data-qty'), 10) || 1) >= (parseInt(gift.getAttribute('data-unlock'), 10) || 5);
      gift.classList.toggle('is-unlocked', unlocked);
      var l = $('[data-gift-locked]', gift), u = $('[data-gift-unlocked]', gift);
      if (l) l.hidden = unlocked; if (u) u.hidden = !unlocked;
      var pk = $('[data-gift-picker]', gift);
      if (pk) {
        if (unlocked && pk.hidden && !pk.getAttribute('data-init')) {
          pk.setAttribute('data-init', '1');
          var first = rowVariants(active)[0] || currentVariant();
          var def = defaultGiftVariant(first);
          if (def) $$('[data-gift-opt]', pk).forEach(function (s) { var v = def.options[parseInt(s.getAttribute('data-gift-opt'), 10)]; if (v != null) s.value = v; });
        }
        pk.hidden = !unlocked;
      }
    }
    function select(t) {
      active = t;
      tiers.forEach(function (x) { var on = x === t; x.classList.toggle('is-active', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      buildRows(t, false); paintGift(); paintAtc();
      if (msg) msg.textContent = '';
    }
    tiers.forEach(function (t) {
      t.addEventListener('click', function (e) { if (e.target.closest('select')) return; select(t); });
      t.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(t); } });
      buildRows(t, true);
    });
    // main variant changes (swatches / sizes handled by nuariva.js) → refresh prices, rows and label
    root.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nua-option]')) return;
      setTimeout(function () { if (!touchedRows) tiers.forEach(function (t) { buildRows(t, true); }); paintPrices(); paintAtc(); }, 0);
    });
    paintPrices(); paintGift(); paintAtc();
    if (gift) $$('[data-gift-opt]', gift).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var opts = $$('[data-gift-opt]', gift).map(function (s) { return s.value; });
        var v = giftList().filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
        if (msg) msg.textContent = (!v || !v.available) ? 'Esa combinación del regalo no está disponible. Elige otra talla o color.' : '';
      });
    });

    function addBundle() {
      var qty = parseInt(active.getAttribute('data-qty'), 10) || 1;
      var vs = rowVariants(active);
      if (!vs.length) { var cv = currentVariant(); for (var i = 0; i < qty; i++) vs.push(cv); }
      if (vs.some(function (v) { return !v || !v.available; })) { msg.textContent = 'Alguna combinación elegida no está disponible. Cambia color o talla.'; return; }
      var grouped = {};
      vs.forEach(function (v) { grouped[v.id] = (grouped[v.id] || 0) + 1; });
      var label = active.getAttribute('data-label') || '';
      var items = Object.keys(grouped).map(function (id) { return { id: parseInt(id, 10), quantity: grouped[id], properties: { _nua_pack: label } }; });
      if (gift && gift.classList.contains('is-unlocked') && gift.getAttribute('data-add') === 'true') {
        var gid = pickGift(vs[0]);
        if (gid) items.push({ id: gid, quantity: 1, properties: { _nua_regalo: '1' } });
      }
      atc.disabled = true;
      fetch(R.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { msg.textContent = res.j.description || res.j.message || 'No se pudo añadir al carrito.'; return; }
          msg.innerHTML = 'Pack añadido al carrito. <a href="' + R.cart + '">Ver carrito</a>';
          return fetch(R.cartJs, { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
            $$('[data-nua-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
          });
        })
        .catch(function () { msg.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.'; })
        .then(function () { atc.disabled = false; });
    }
    function giftList() { var l = []; try { l = JSON.parse(($('[data-nua-gift-json]', bundle) || {}).textContent || '[]'); } catch (e) {} return l; }
    /* Gift variant chosen by the customer in the picker; otherwise a sensible default. */
    function pickGift(ref) {
      var pk = gift && $('[data-gift-picker]', gift);
      if (pk && !pk.hidden) {
        var opts = $$('[data-gift-opt]', pk).map(function (s) { return s.value; });
        var chosen = giftList().filter(function (v) { return v.options.every(function (o, i) { return opts[i] == null || o === opts[i]; }); })[0];
        if (chosen && chosen.available) return chosen.id;
      }
      var d = defaultGiftVariant(ref);
      return d ? d.id : (parseInt(gift.getAttribute('data-variant'), 10) || null);
    }
    /* Default: same size as the first chosen item when the gift has it, preferring an assorted colour. */
    function defaultGiftVariant(ref) {
      var list = giftList().filter(function (v) { return v.available; });
      if (!list.length) return null;
      var norm = function (x) { return String(x || '').toLowerCase().trim(); };
      var isSize = function (o) { return /^(\d?x{0,3}[sml]|\d?xl|\d+)$/.test(norm(o)); };
      var refSizes = ref ? ref.options.map(norm).filter(isSize) : [];
      var sameSize = list.filter(function (v) { return v.options.some(function (o) { return isSize(o) && refSizes.indexOf(norm(o)) > -1; }); });
      var pool = sameSize.length ? sameSize : list;
      var assorted = pool.filter(function (v) { return v.options.some(function (o) { return /surtid|mix|variad/.test(norm(o)); }); })[0];
      return assorted || pool[0];
    }
    function wantsBundle() { return (parseInt(active.getAttribute('data-qty'), 10) || 1) > 1; }
    document.addEventListener('submit', function (e) {
      if (!root.contains(e.target) || !wantsBundle()) return;
      e.preventDefault(); e.stopImmediatePropagation(); addBundle();
    }, true);
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nua-sticky-add]') || !wantsBundle()) return;
      e.preventDefault(); e.stopImmediatePropagation(); addBundle();
    }, true);
  });

  /* ================= Product card markup (for JS-built rows) ================= */
  function cardHTML(p) {
    var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    var price = p.price, cmp = p.compare_at_price;
    return '<div class="nua-hscroll__item"><div class="nua-card nua-card--related"><a href="' + esc(p.url) + '">' +
      '<div class="nua-card__media">' + (img ? '<img src="' + esc(img) + (img.indexOf('?') > -1 ? '&' : '?') + 'width=480" alt="' + esc(cleanTitle(p.title)) + '" loading="lazy" width="480" height="640">' : '<div class="nua-card__ph"></div>') + '</div>' +
      '<h3>' + esc(cleanTitle(p.title)) + '</h3><p class="nua-card__price"><strong>' + esc(money(price)) + '</strong>' +
      (cmp && cmp > price ? ' <s>' + esc(money(cmp)) + '</s>' : '') + '</p></a></div></div>';
  }

  /* ================= Also bought (Shopify recommendations) ================= */
  $$('[data-nua-also]').forEach(function (sec) {
    var url = sec.getAttribute('data-url'); if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var list = $('[data-nua-also-list]', tmp);
      if (list && $$('.nua-hscroll__item', list).length >= 2) $('[data-nua-also-list]', sec).innerHTML = list.innerHTML;
    }).catch(function () {});
  });

  /* ================= Recently viewed ================= */
  $$('[data-nua-recent]').forEach(function (sec) {
    var KEY = 'nua_recent', cur = sec.getAttribute('data-current'), max = parseInt(sec.getAttribute('data-max'), 10) || 6;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { list = []; }
    var show = list.filter(function (h) { return h && h !== cur; }).slice(0, max);
    try { localStorage.setItem(KEY, JSON.stringify([cur].concat(list.filter(function (h) { return h !== cur; })).slice(0, 12))); } catch (e) {}
    if (!show.length) return;
    Promise.all(show.map(function (h) {
      return fetch((R.root || '/').replace(/\/?$/, '/') + 'products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (prods) {
      prods = prods.filter(Boolean);
      if (!prods.length) return;
      $('[data-nua-recent-list]', sec).innerHTML = prods.map(cardHTML).join('');
      sec.hidden = false;
    });
  });

  /* ================= Footer accordion (mobile) ================= */
  $$('.nua-footer__grid > div').forEach(function (col) {
    var h = $('h2', col); if (!h) return;
    col.classList.add('nua-footer__col--acc');
    h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0');
    function toggle() { if (!isMobile()) return; var o = col.classList.toggle('is-open'); h.setAttribute('aria-expanded', o ? 'true' : 'false'); }
    h.addEventListener('click', toggle);
    h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } });
  });
})();
